import styled, {css} from "styled-components"

import IconButton from "../../Button/IconButton"

export default styled(IconButton)`
  position: absolute;
  ${({theme}) => css`
    top: ${theme.spacing.one};
    right: ${theme.spacing.four};
  `}
`
